function copyDiscountCode() {
        // Testo del codice sconto
        var discountCode = "BLACK17";
        
        // Copia il testo negli appunti senza input visibile
        navigator.clipboard.writeText(discountCode).then(function() {
            // Mostra il messaggio di conferma
            var message = document.getElementById("copyMessage");
            message.style.display = "block";
            setTimeout(function() {
                message.style.display = "none";
            }, 2000);
        }).catch(function(error) {
            console.error("Errore nel copiare il codice: ", error);
        });
}

(function () {
  function launchSunConfetti(x, y) {
    var count = 20;
    for (var i = 0; i < count; i++) {
      var emoji = document.createElement('span');
      emoji.className = 'confetti-emoji';
      emoji.textContent = '🍁';
      emoji.style.left = x + 'px';
      emoji.style.top = y + 'px';
      document.body.appendChild(emoji);

      var angle = Math.random() * Math.PI * 2;
      var velocity = 70 + Math.random() * 110;
      var tx = Math.cos(angle) * velocity;
      var ty = Math.sin(angle) * velocity - 90;
      var rotation = (Math.random() - 0.5) * 720;
      var duration = 650 + Math.random() * 450;

      emoji.animate(
        [
          { transform: 'translate(0,0) rotate(0deg) scale(1)', opacity: 1 },
          { transform: 'translate(' + tx + 'px,' + (ty + 260) + 'px) rotate(' + rotation + 'deg) scale(0.6)', opacity: 0 }
        ],
        { duration: duration, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'forwards' }
      );

      (function (el, d) {
        setTimeout(function () { el.remove(); }, d + 50);
      })(emoji, duration);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // querySelectorAll: nel caso il selettore matchi più elementi (es. header desktop + mobile)
    var buttons = document.querySelectorAll(
      '.header__menu-labels a.flex.header__menu-labels__item.link.align-center'
    );

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var href = btn.getAttribute('href');
        var rect = btn.getBoundingClientRect();
        var x = rect.left + rect.width / 2;
        var y = rect.top + rect.height / 2;

        launchSunConfetti(x, y);

        if (href && href !== '#') {
          e.preventDefault();
          setTimeout(function () {
            window.location.href = href;
          }, 450);
        }
      });
    });
  });
})();